import React, { useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

export const WindowChanger = () => {
  const Height = useSelector((state) => state.ui.height);
  const ref = useRef();
  const [circleSize, setCircleSize] = useState(0);
  const Width = useSelector((state) => state.ui.width);

  useLayoutEffect(() => {
    if (ref?.current?.clientWidth) setCircleSize(ref?.current?.clientWidth);
  }, [setCircleSize, Width, Height]);
  return (
    <div className="window-changer-wrapper">
      <div className="window-changer-container">
        <div
          ref={ref}
          className="inner-circle"
          style={{ width: 200, height: 200 }}
        >
          <div
            className="outer-circle1"
            style={{ height: circleSize, width: circleSize }}
          ></div>
          <div
            className="outer-circle2"
            style={{ height: circleSize + 10, width: circleSize + 10 }}
          ></div>
          <div
            className="outer-circle3"
            style={{ height: circleSize + 20, width: circleSize + 20 }}
          ></div>
        </div>
      </div>
    </div>
  );
};
